import styled from 'styled-components';

export const Typography = styled.div`
  color: ${({ theme }) => theme.colors.text01};
  letter-spacing: 0px;
  &&&.disabled,
  &&&.description {
    color: ${({ theme }) => theme.colors.text04};
  }
  &&&.blue {
    color: ${({ theme }) => theme.colors.text05};
  }
  &&&.info {
    color: ${({ theme }) => theme.colors.text03};
  }
  &&&.link {
    color: ${({ theme }) => theme.colors.brand03};
  }
  &&&.uppercase {
    text-transform: uppercase;
  }
  &&&.bold {
    font-weight: 700;
  }
  &&&.semi-bold {
    font-weight: 600;
  }
  &&&.medium {
    font-weight: 500;
  }
  &&&.regular {
    font-weight: 400;
  }
  &&&.italic {
    font-style: italic;
  }
  &&&.inherit {
    color: inherit;
  }
  &&&.nowrap {
    white-space: nowrap;
  }
  &&&.hidden {
    overflow: hidden;
  }
  &&&.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &&&.error {
    color: ${({ theme }) => theme.colors.errorRed01};
  }
  &&&.danger {
    color: ${({ theme }) => theme.colors.errorRed01};
  }
  &&&.inline {
    display: inline-block;
  }
`;

export const HeadingLarge = styled(Typography)`
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
`;
HeadingLarge.displayName = 'HeadingLarge';

export const HeadingMedium = styled(Typography)`
  font-weight: 500;
  font-size: 24px;
`;
HeadingMedium.displayName = 'HeadingMedium';

export const HeadingSmall = styled(Typography)`
  font-weight: 500;
  font-size: 21px;
`;
HeadingSmall.displayName = 'HeadingSmall';

export const BodyLarge = styled(Typography)`
  font-size: 16px;
  font-weight: 500;
`;
BodyLarge.displayName = 'BodyLarge';

export const BodySmall = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
`;
BodySmall.displayName = 'BodySmall';

export const BodyMedium = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
`;
BodyMedium.displayName = 'BodyMedium';

export const BodyRegular = styled(Typography)`
  font-size: 14px;
  color: ${({ theme }) => theme.colors.text02};
`;
BodyRegular.displayName = 'BodyRegular';
